<template>
  <CRow>
    <CCol sm="12">
      <CCard v-if="restaurant">
        <CCardHeader>
          <CIcon name="cil-dinner" />
          <h5 class="d-inline ml-2">
            <h3 class="d-inline">
              <CBadge color="secondary">{{ restaurant.restaurant_name }}</CBadge>
            </h3>
            Menu Items
          </h5>
          <div class="card-header-actions d-flex flex-gap-2">
            <CButton color="info" :to="{ name: 'OptionGroups', params: { 'restaurant_id': restaurantId } }" class="d-flex align-items-center flex-gap-1">
              <CIcon name="cil-list-rich" class="align-bottom" />Option Groups
            </CButton>

            <CButton color="success" @click="$store.commit('set', ['bulkMenuUpdateShow', true])" class="d-flex align-items-center flex-gap-1">
              <CIcon name="cil-layers" class="align-bottom" />Bulk <strong>Update</strong>
            </CButton>

            <CButton color="primary" :to="{ name: 'AddNewMenuItem' }" class="d-flex align-items-center flex-gap-1">
              <CIcon name="cil-plus" class="align-bottom" /><strong>Add New</strong> Menu Item
            </CButton>

            <CDropdown color="dark" toggler-text="Back" placement="bottom-end">
              <template #toggler>
                <CButton color="dark">
                  <CIcon name="cil-arrow-thick-left" class="align-bottom" /> Back
                  <CIcon name="cil-chevron-bottom" class="ml-1" />
                </CButton>
              </template>

              <CDropdownItem v-if="restaurantId" :to="{ name: 'View Restaurant', params: { 'id': restaurantId } }">
                <CIcon name="cil-restaurant" class="mr-2" /> Back To Restaurant
              </CDropdownItem>

              <CDropdownItem v-if="restaurantId" :to="{ name: 'RestaurantLinkedCategories', params: { restaurant_id: restaurantId } }">
                <CIcon name="cil-folder" class="mr-2" /> Categories
              </CDropdownItem>

              <CDropdownItem :to="prevRoute">
                <CIcon name="cil-arrow-left" class="mr-2" /> Previous Page
              </CDropdownItem>
            </CDropdown>
          </div>
        </CCardHeader>

        <BackendTable :usetoprice="restaurant.usetoprice" ref="menuV2Table" />

        <BulkMenuUpdate :restaurant="{ id: restaurantId, usetoprice: restaurant.usetoprice }" @updated="menusUpdated" />
      </CCard>

      <div v-else>
        <CSpinner v-if="loading" color="primary" />
        <h6 v-else>Restaurant not found!</h6>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";
import BulkMenuUpdate from "@/components/BulkMenuUpdate";

export default {
  name: "RestaurantMenuItems",
  components: {
    BackendTable,
    BulkMenuUpdate,
  },
  data() {
    return {
      restaurant: null,
      loading: true,

      // Previous page
      prevRoute: null,
    };
  },

  // Get previous page
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },

  // beforeRouteLeave: function (to, from, next) {
  //   // Indicate to the SubComponent (BackendTable) that we are leaving the route
  //   // Make sure to always call the next function, otherwise the hook will never be resolved
  //   // Ref: https://router.vuejs.org/en/advanced/navigation-guards.html
  //   next(this.$refs.menuV2Table.prepareToExit());
  // },

  async mounted() {
    await this.getRestaurant();
  },
  computed: {
    restaurantId() { return this.$route.params.restaurant_id; },
  },
  methods: {
    async getRestaurant() {
      await this.$axios
        .get(this.$backend.RESTAURANT.GET_NAME.replace("{id}", this.restaurantId), {
          params: {
            fields: 'usetoprice'
          }
        })
        .then((response) => {
          this.restaurant = response.data;
        })
        .finally(() => this.loading = false);
    },

    menusUpdated(result) {
      // result: { "message": "", "data": [] }
      this.$refs.menuV2Table.getAllItems()
    }
  },
};
</script>
